module.exports = __webpack_public_path__ + "img/operations.39f1b4f6.svg";